import React, { useContext } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import TopBar from '@msteams/components/TopBar'
import GlobalContext from '@msteams/GlobalContext'
import NoConsentGrantedBanner from '@msteams/components/NoConsentGrantedBanner'

import { isFullBleedRoute } from '@src/Routes/routes'

import { AppScope } from '@msteams/types/common'

const AppLayout = () => {
  const { scope } = useContext(GlobalContext)
  const { pathname } = useLocation()

  // Mirrors the web Layout's carve-out (src/components/Layout/index.tsx):
  // full-bleed pages own their height and their scroll containers, so the
  // shell contributes neither padding nor a second scrollbar.
  //
  // Plain utilities here, `!important` ones on web, and that asymmetry is
  // deliberate: this base is a literal utility string that twMerge can strip,
  // whereas web's base is a hashed CSS-module class it cannot see into. Do not
  // "unify" the two strings — twMerge leaves `px-3 py-4` in place next to
  // `!p-0`, so the important variant would only work here by accident.
  const isFullBleed = isFullBleedRoute(pathname)

  return (
    <>
      <NoConsentGrantedBanner />
      {scope === AppScope.personal && <TopBar />}
      <div className={twMerge('px-3 py-4 flex-1 min-h-0 overflow-auto', isFullBleed && 'p-0 overflow-hidden')}>
        <Outlet />
      </div>
    </>
  )
}
export default AppLayout
